module.exports = __webpack_public_path__ + "static/media/about.e5b08330.jpg";